define.alias("shared/components/shared/social/instagram-connect-modal", "media/components/shared/social/instagram-connect-modal");